export default __webpack_public_path__ + "static/media/ST4_DEEP_MOIST_550_M.4e213366.png";